var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfoRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0239 4.08594C6.3155 4.08594 4.1123 6.28914 4.1123 8.99754C4.1123 11.7059 6.3155 13.9091 9.0239 13.9091C11.7323 13.9091 13.9355 11.7059 13.9355 8.99754C13.9355 6.28914 11.7323 4.08594 9.0239 4.08594ZM9.0239 13.6691C6.4487 13.6691 4.3523 11.5727 4.3523 8.99754C4.3523 6.42234 6.4487 4.32594 9.0239 4.32594C11.5991 4.32594 13.6955 6.42234 13.6955 8.99754C13.6955 11.5727 11.5991 13.6691 9.0239 13.6691Z",
    fill: "#004C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02437 4.56641C6.57757 4.56641 4.59277 6.55121 4.59277 8.99801C4.59277 11.4448 6.57757 13.4296 9.02437 13.4296C11.4712 13.4296 13.456 11.4448 13.456 8.99801C13.456 6.55121 11.4712 4.56641 9.02437 4.56641ZM9.88717 12.412C9.88717 12.4804 9.82837 12.5404 9.75997 12.5404H8.25757C8.18917 12.5404 8.13037 12.4804 8.13037 12.412V7.96721C8.13037 7.90721 8.18917 7.84721 8.25757 7.84721H9.75997C9.82837 7.84721 9.88717 7.90721 9.88717 7.96721V12.412ZM9.00037 7.17881C8.43757 7.17881 8.06197 6.83801 8.06197 6.33521C8.06197 5.80601 8.43757 5.45561 9.00037 5.45561C9.56317 5.45561 9.93877 5.80601 9.93877 6.33521C9.93877 6.86441 9.56317 7.17881 9.00037 7.17881Z",
    fill: "#004C3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoRounded);
export default __webpack_public_path__ + "static/media/IconInfoRounded.3208eea49b943146d765cbe759c72d72.svg";
export { ForwardRef as ReactComponent };